import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Header from '../../includes/Header';
import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { FaSyncAlt, FaFilter, FaCameraRetro, FaImage } from "react-icons/fa";
import ListCard from '../../components/ListCard/ListCard';
import DateFild from '../../components/DateTimePicker/DateFild';
import { getStatusList, getRiskAsessment, postIncidentListing, postFinalReportPdf } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import { Modal } from 'react-bootstrap';

const Home = () => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [airpotList, setAirpotList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [data, setData] = useState([]);
    const [msg, setMsg] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [preview, setPreview] = useState(null);
    const [selectdImg, setSelectdImg] = useState(null);
    const [hasCamera, setHasCamera] = useState(false);

    const captureInputRef = useRef(null);
    const galleryInputRef = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        navigator.mediaDevices?.enumerateDevices()
            .then(devices => {
                const videoInputs = devices.filter(device => device.kind === 'videoinput');
                setHasCamera(videoInputs.length > 0);
            })
            .catch(() => {
                setHasCamera(false);
            });
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectdImg(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSaveAndClose = () => {
        if (selectdImg) {
            const reader = new FileReader();
            reader.onload = () => {
                localStorage.setItem(
                    'homeModalImage',
                    JSON.stringify({
                        name: selectdImg.name,
                        type: selectdImg.type,
                        data: reader.result
                    })
                );
                setShowModal(false);
                navigate("/case");
            };
            reader.readAsDataURL(selectdImg);
        } else {
            setShowModal(false);
            navigate("/case");
        }
    };

    const handleCloseModal = () => {
        setPreview(null);
        setShowModal(false);
    };

    const [filters, setFilters] = useState({
        riskScore: '',
        startDate: '',
        endDate: '',
        status: '',
        caseType: '',
    });

    const getRiskAsessments = async () => {
        try {
            const res = await getRiskAsessment();
            setAirpotList(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const getStatusLists = async () => {
        try {
            const res = await getStatusList();
            setStatusList(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const postIncidentListings = async (postdata) => {
        try {
            const res = await postIncidentListing(postdata);
            setData(res.data.data);
            setMsg(res.data.message)
            console.log(res.data.message);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            console.log(error);
        }
    };

    const finalReport = async (Slug, Classification, CaseType, Time, DateStr) => {
        setLoadings(true);
        const postData = { slug: Slug };

        const [day, month, year] = DateStr.split('/');
        const dateObj = new Date(`${year}-${month}-${day}`);
        const dayPart = dateObj.getDate().toString().padStart(2, '0');
        const monthPart = dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // "JUL"
        const yearPart = dateObj.getFullYear();

        const formattedDate = `${dayPart} ${monthPart} ${yearPart}`;

        const monthNum = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Add this
        const rname = `${year}${monthNum}${dayPart}`;
        const newrep = Slug.replace(rname, '');
        const finalRep = newrep.replace(/^[A-Z]{3}/, '');

        try {
            const res = await postFinalReportPdf(postData);
            const file = new Blob([res.data], { type: 'application/pdf' });

            const blobUrl = window.URL.createObjectURL(file);

            // Open in new tab
            window.open(blobUrl, '_blank');

            // Download the file
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `Final ${Classification} Related ${CaseType} Report at ${Slug} ${formattedDate} ${Time}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();

            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error?.response?.data?.message || "Failed to download PDF");
        }
    };

    const isMobileOrTablet = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|ipad|iphone|ipod/i.test(userAgent.toLowerCase());
    };

    const initialReport = (PDFUrl, Slug, Classification, CaseType, Time, DateStr) => {
        const [day, month, year] = DateStr.split('/');
        const dateObj = new Date(`${year}-${month}-${day}`);
        const dayPart = dateObj.getDate().toString().padStart(2, '0');
        const monthPart = dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // "JUL"
        const yearPart = dateObj.getFullYear();

        const formattedDate = `${dayPart} ${monthPart} ${yearPart}`;

        const monthNum = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Add this
        const rname = `${year}${monthNum}${dayPart}`;
        const newrep = Slug.replace(rname, '');
        const finalRep = newrep.replace(/^[A-Z]{3}/, '');

        if (isMobileOrTablet()) {
            const link = document.createElement('a');
            link.href = PDFUrl;
            link.download = `1st_Initial_${Classification}_Related_${CaseType}_Report_at_${Slug}_${formattedDate}_${Time}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            window.open(PDFUrl, '_blank');
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('useToken')) {
            navigate("/");
        }
        else {
            getRiskAsessments();
            getStatusLists();
            let postData = {

            }
            postIncidentListings(postData);
        }
    }, []);

    useEffect(() => {
        setLoadings(true);
        const formData = new FormData();
        formData.append("risk_level", filters.riskScore);
        formData.append("status", filters.status);
        formData.append("casetype", filters.caseType);
        formData.append("startDate", filters.startDate);
        formData.append("endDate", filters.endDate);

        postIncidentListings(formData);
    }, [filters]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (fieldName, value) => {
        setFilters(prev => ({ ...prev, [fieldName]: value }));
    };

    const hendelResat = () => {
        setLoadings(true);
        setFilters({
            riskScore: '',
            startDate: '',
            endDate: '',
            status: '',
            caseType: '',
        })
    }

    return (
        <>
            <Header />
            <ToastContainer />
            {isLoading ? (
                <Loader />
            ) : (
                <>

                    <div className='buttonGrids'>
                        <div className='buttonGrids-block'>
                            <Container>
                                <div className='buttonGrids-box'>
                                    <div>
                                        <button className='btn btn-black' onClick={() => setShowModal(true)}><FaCameraRetro /> Add New</button>
                                        <Link className='btn btn-orange' to={'/case'}>Add New</Link>
                                    </div>
                                    <button className='btn btn-orange' onClick={hendelResat}><FaSyncAlt />Filters</button>
                                </div>
                            </Container>
                        </div>
                    </div>

                    <section id='filters'>
                        <div className='filters-block'>
                            <Container>
                                <div className='filter-panel'>
                                    <Row>
                                        <Col md={3}>
                                            <div className="form-group">
                                                <label>Risk Score</label>
                                                <select className="form-control" name="riskScore" value={filters.riskScore} onChange={handleChange}>
                                                    <option value="">All Risk Score</option>
                                                    {airpotList.map((item) => (
                                                        <option key={item.RiskDes} value={item.RiskDes}>{item.RiskDes}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-group">
                                                <label>From Date</label>
                                                <DateFild
                                                    value={filters.startDate}
                                                    onChange={(date) => handleDateChange('startDate', date)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-group">
                                                <label>To Date</label>
                                                <DateFild
                                                    value={filters.endDate}
                                                    onChange={(date) => handleDateChange('endDate', date)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-group">
                                                <label>Status</label>
                                                <select className="form-control" name="status" value={filters.status} onChange={handleChange}>
                                                    <option value="">All</option>
                                                    {statusList.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.status_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-group">
                                                <label>Case Type</label>
                                                <select className="form-control" name="caseType" value={filters.caseType} onChange={handleChange}>
                                                    <option value="all">All</option>
                                                    <option value="Incident">Incident</option>
                                                    <option value="Accident">Accident</option>
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='RiskscoreList'>
                                    <ul>
                                        {airpotList.map((item) => (
                                            <li key={item.ToScore}><span style={{ backgroundColor: item.RiskColorCode }}></span> {item.RiskDes}</li>
                                        ))}
                                    </ul>
                                </div>
                            </Container>
                        </div>
                    </section>

                    <section id="listing">
                        <div className="listing-block">
                            <Container>
                                <div className="listing-box">
                                    <Row>
                                        {data && data.length > 0 ? (
                                            data.map((item) => (
                                                <Col md={4} key={item.report_number}>
                                                    <ListCard
                                                        Status={item.status_name}
                                                        ReportNumber={item.report_number}
                                                        AirportName={item.airport_name}
                                                        ICAOCode={item.icao_code}
                                                        Date={item.incident_date}
                                                        Time={item.incident_time}
                                                        CaseType={item.case_type}
                                                        Classification={item.incident_classification}
                                                        Riskscore={item.risk_score}
                                                        Slug={item.slug}
                                                        PDFUrl={item.pdf_path}
                                                        finalReport={finalReport}
                                                        initialReport={initialReport}
                                                    />
                                                </Col>
                                            ))
                                        ) : (
                                            <Col md={12}>
                                                <div className='nodata'>
                                                    <p>{msg}</p>
                                                    <br />
                                                    <button className="filter-reset" onClick={hendelResat}>
                                                        <FaSyncAlt /> <span>Reset Filters</span>
                                                    </button>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            </Container>
                        </div>
                    </section>

                    <Modal show={showModal} onHide={() => setShowModal(false)} size="md" centered scrollable>
                        <Modal.Header>
                            <Modal.Title>Select Image & Add New Case</Modal.Title>
                            <button onClick={handleCloseModal} type="button" class="btn-close" aria-label="Close"></button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className='buttonboxs Options'>
                                {hasCamera && (
                                    <>
                                        <button className='btn btn-orange' onClick={() => captureInputRef.current.click()}><FaCameraRetro /> Take Photo</button>
                                        <input
                                            ref={captureInputRef}
                                            type="file"
                                            accept="image/*"
                                            capture="environment"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                        />
                                    </>
                                )}

                                <button className='btn btn-orange' onClick={() => galleryInputRef.current.click()}><FaImage /> Select Image </button>
                                <input
                                    ref={galleryInputRef}
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                            </div>

                            {preview && (
                                <div style={{ marginTop: '20px' }}>
                                    <img
                                        src={preview}
                                        alt="Selected"
                                        style={{ maxWidth: '100%', borderRadius: '8px' }}
                                    />
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-red" onClick={handleSaveAndClose}>AI Safety Genie Analyzes</button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}

            {isLoadings ? (
                <Loader />
            ) : null}
        </>
    );
}

export default Home;